@if (rows().length > 0) {
  <div class="overflow-hidden rounded-sm border" [class]="boxClass()">
    @if (!dense()) {
      <button
        type="button"
        data-testid="deploy-warnings-collapse"
        class="border-weak flex w-full cursor-pointer items-center gap-2 px-3 py-1.5 text-left transition-opacity hover:opacity-80"
        [class.border-b]="expanded()"
        [attr.aria-expanded]="expanded()"
        (click)="expanded.set(!expanded())">
        <i [class]="ICONS.warning" class="text-warning text-xs"></i>
        <span class="text-text-secondary text-xs font-semibold">
          {{
            'features.plan.deploy.warnings.heading' | translate: { count: rows().length }
          }}
        </span>
        <i
          [class]="ICONS.caretDown"
          class="text-text-tertiary ml-auto text-[10px] transition-transform"
          [class.rotate-180]="expanded()"></i>
      </button>
    }

    @if (dense() || expanded()) {
      <ul class="flex flex-col">
        @for (row of rows(); track $index) {
          <li class="border-weak flex flex-col gap-1 border-b px-3 py-2 last:border-b-0">
            <p class="text-text-primary text-xs leading-relaxed break-words">
              {{ row.body }}
            </p>

            @if (row.refs.length > 0) {
              <div class="flex flex-wrap gap-1.5">
                @for (ref of row.refs; track ref.label) {
                  <span
                    data-testid="deploy-warning-ref"
                    class="bg-surface border-weak text-text-secondary flex items-center gap-1 rounded-sm border px-1.5 py-0.5 text-[10.5px]">
                    <i [class]="entityIcon(ref.entityType)" class="text-text-tertiary"></i>
                    <span class="font-mono">{{ ref.uid ?? ref.label }}</span>
                  </span>
                }
              </div>
            }

            @if (row.fields.length > 0) {
              <dl class="flex flex-wrap gap-x-4 gap-y-0.5">
                @for (field of row.fields; track field.key) {
                  <div
                    data-testid="deploy-warning-field"
                    [attr.data-field]="field.key"
                    class="flex items-baseline gap-1">
                    <dt class="text-text-tertiary text-[10.5px]">{{ field.label }}</dt>
                    <dd class="text-text-secondary font-mono text-[10.5px] tabular-nums">
                      {{ field.value }}
                    </dd>
                  </div>
                }
              </dl>
            }
          </li>
        }
      </ul>
    }
  </div>
}
